<template>
  <div class="main" v-on:click="notificationPopup()">
    <template v-if="getAppLoader">
      <div
        :class="sideClass"
        class="project_sidebar"
        :style="`width:232px;min-width: 232px;${
          $route.params.chat_id ? 'z-index: 99' : ''
        }`"
        ref="collapse_sidebar"
      >
        <Loader type="saidbar" />
      </div>
      <div
        :class="sideClass"
        class="main-content"
        :style="`width:${mainSpan}px;min-width: 800px`"
      >
        <Loader type="main" />
      </div>
    </template>
    <OnboardLayout
      v-else-if="!onboard"
      @onboardFinished="onboardFinished"
    ></OnboardLayout>
    <template v-else>
      <div
        :class="sideClass"
        class="project_sidebar"
        :style="`width:232px;min-width: 232px;${
          $route.params.chat_id ? 'z-index: 99' : ''
        }`"
        ref="collapse_sidebar"
      >
        <left-sidebar @toggle_collapse="toggle_collapse" />
      </div>
      <div
        :class="sideClass"
        class="main-content"
        :style="`width:${mainSpan}px;min-width: 800px`"
      >
        <router-view />
      </div>
    </template>

    <div ref="onboard_backgraund" class="onboard_backgraund"></div>

    <div
      ref="circle"
      class="circle"
      :style="{ top: circleY + 'px', left: circleX + 'px' }"
    >
      <img :src="require(`@/assets/static/images/mouse_arrow.png`)" alt="" />
    </div>

    <AddRenameProjectAddUser />
    <SettingsTemplate v-if="!getAppLoader"></SettingsTemplate>
    <LightBox />
    <Popup v-if="!getAppLoader" />

    <div class="alert" v-if="alerts.length > 0 && !getAppLoader">
      <div
        v-for="(alert, i) of alerts"
        :key="i"
        :class="alert.class"
        :style="alert.icon ? '' : 'justify-content: center;'"
      >
        <div class="alert-message__icon" v-if="alert.icon">
          <div
            :class="
              alert.text == $t('app.alert.synced') ? 'loader stop' : 'loader'
            "
          ></div>
        </div>
        <div class="alert-message__text">
          {{ alert.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftSidebar from "@/components/app/LeftSidebar.vue";
import LightBox from "@/components/app/LightBox.vue";
import Popup from "../components/app/Popup.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AddRenameProjectAddUser from "@/components/projects/AddRenameProjectAddUser";
import SettingsTemplate from "../components/app/SettingsTemplate.vue";
import OnboardLayout from "./OnboardLayout.vue";
import { EventEmitter } from "../main";

export default {
  name: "MainLayout",
  data() {
    return {
      circleX: 50,
      circleY: 50,
      sideSpan: 232,
      mainSpan: 1625,
      sideClass: "",
      interval: "",
      reconnectTimeout: null,
      alerts: [],
      connect_bool: true,
      onboard: true,
      isRefreshingSocketToken: false,
      isLoggingOut: false,
    };
  },
  sockets: {
    connect: async function () {
      console.log("Socket Connect");

      this.alerts = [
        {
          icon: true,
          text: this.$t("app.alert.syncing"),
          class: "alert-message",
        },
      ];

      clearInterval(this.interval);
      clearTimeout(this.reconnectTimeout);
      await this.handleGetData();
    },
    disconnect: async function (e) {
      console.log("Socket Disconnect");
      console.log(e.message);

      this.handleSocketDisconnected();

      if (this.isRefreshingSocketToken || this.isLoggingOut) {
        return;
      }

      let task_message = localStorage.getItem("task_message");

      if (task_message) {
        let task_message_array = JSON.parse(task_message);
        EventEmitter.$emit("noSendMessages", task_message_array);
        this.changeCommentLoading();
      }

      clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = setTimeout(() => {
        this.$socket.connect();
      }, 1000);

      clearInterval(this.interval);
      this.interval = setInterval(() => {
        console.log("setInterval:30");
        this.$socket.connect();
      }, 30000);
    },
    connect_error: async function (e) {
      console.log("Socket Connect Error");
      console.log(e.message);

      if (e.message == "jwt expired") {
        if (this.isRefreshingSocketToken) return;
        this.isRefreshingSocketToken = true;

        clearInterval(this.interval);
        clearTimeout(this.reconnectTimeout);

        let check_token = await this.check_token();
        if (check_token) {
          this.$socket.disconnect();
          this.syncSocketAuthorization();
          this.$socket.connect();
        } else if (check_token === "reconnect") {
          this.$socket.disconnect();
          this.syncSocketAuthorization();
          this.$socket.connect();
        }

        this.isRefreshingSocketToken = false;
        return;
      }
      // if (e.message == "invalid token") {
      //   this.forceLogout();
      // }
    },
  },
  components: {
    LeftSidebar,
    LightBox,
    AddRenameProjectAddUser,
    SettingsTemplate,
    Popup,
    OnboardLayout,
  },
  async mounted() {
    // if (true) {
    //   this.$socket.emit('IN_ActionListChat', {
    //     method: "updateUsers",
    //     entity: "chat",
    //     action: "add",
    //     payload: {
    //       _id: "CDkjY0Nns1EVCOU4LPqLCGg=",
    //       users: ["69786b5b0f875748c684cc79"]
    //     }
    //   })
    // }

    this.syncSocketAuthorization();
    this.$socket.connect();

    window.addEventListener("offline", (event) => {
      console.log("offline");
      this.$socket.disconnect();
      this.handleSocketDisconnected();
    });

    window.addEventListener("online", async (event) => {
      console.log("online");
      this.syncSocketAuthorization();
      this.$socket.connect();
    });

    this.onAppLoader();

    this.watchWindowWidth();

    setTimeout(() => {
      this.changeTitle(this.$route);
    }, 1000);

    EventEmitter.$on("SOCKET_OUT_ImportData", (data) => {
      if (data) {
        setTimeout(() => {
          window.location.href = window.location.href;
        }, 3000);
      }
    });
  },
  methods: {
    ...mapActions([
      "check_token",
      "fetchUserData",
      "socket_send_firebase_token",
      "SOCKET_IN_Company",
      "getData",
      "addChatUnreadMessagesRecievedWhileUpdating",
    ]),
    ...mapMutations([
      "onAppLoader",
      "setShowSmalActivityLog",
      "changeCommentLoading",
      "renderImageTeamsAndKnow",
    ]),
    syncSocketAuthorization() {
      this.$socket.io.opts.transportOptions.polling.extraHeaders.Authorization =
        localStorage.getItem("w_token");
    },
    onboardFinished(data) {
      if (data == null) return;
      this.alerts.push({
        icon: true,
        text: this.$t("onboard.alert"),
        class: "alert-message alert-message_top",
      });
      this.$root.$emit("onboard:alert", true);
      this.onboard = true;
      this.$nextTick(() => {
        this.$refs.circle.style.display = "block";
        this.$refs.onboard_backgraund.style.display = "block";
      });
      setTimeout(() => {
        this.onboardCreateList(data).then(() => {
          setTimeout(() => {
            this.onboardCreateTask(data).then(() => {
              setTimeout(() => {
                if (data.email) {
                  this.onboardShare(data);
                } else {
                  this.$nextTick(() => {
                    this.$refs.circle.style.display = "none";
                    this.$refs.onboard_backgraund.style.display = "none";
                  });
                  this.alerts = [];
                  this.$root.$emit("onboard:alert", false);
                  this.$socket.emit("IN_Onboard", { type: "finish" });
                }
              }, 1000);
            });
          }, 1000);
        });
      }, 500);
    },
    changeTitle(to) {
      let title = "TaskPal";

      if (to.params.project_id) {
        this.getProjects.forEach((e) => {
          if (e._id == to.params.project_id) {
            title = e.name;
          }
        });
      }

      if (to.params.chat_id) {
        this.getChats.forEach((e) => {
          if (e._id == to.params.chat_id) {
            title = e.name;
          }
        });
      }

      if (to.name == "shortcuts") {
        if (to.params.shortcuts == "high_priority") {
          title = this.$t("app.shortcuts.high_priority");
        }
        if (to.params.shortcuts == "today") {
          title = this.$t("app.shortcuts.today");
        }
        if (to.params.shortcuts == "assigned_to_me") {
          title = this.$t("app.shortcuts.assigned_to_me");
        }
        if (to.params.shortcuts == "medium_priority") {
          title = this.$t("app.shortcuts.medium_priority");
        }
      }

      document.title = title + ": TaskPal";
    },
    notificationPopup() {
      if (Notification.permission !== "granted") {
        Notification.requestPermission();
      }
    },
    watchWindowWidth() {
      const width = window.innerWidth;
      if (width > 1024) {
        this.sideSpan = 232;
        this.sideClass = "";
      } else if (width <= 1024) {
        this.sideSpan = 40;
      }
      this.mainSpan = width - this.sideSpan;

      // if (width <= 1024) {
      //   this.sideClass = "sidebar_collapse active"
      // }
    },
    toggle_collapse() {
      this.$refs.collapse_sidebar.classList.toggle("active");
    },
    resetSubtaskOpen() {
      const len = Object.keys(this.getTasks).length;
      if (len > 0) {
        for (let list in this.getTasks) {
          const currentProject = this.getTasks[list];
          for (let i = 0; i < currentProject.length; i++) {
            if (currentProject[i].parent && currentProject[i].unread_message) {
              localStorage.setItem(currentProject[i].parent, true);
              EventEmitter.$emit("openSubtask", currentProject[i]._id);
              i = currentProject.length + 5;
            }
          }
        }
      }
    },
    async handleGetData() {
      return await this.getData()
        .then((res) => {
          this.resetSubtaskOpen();
          this.alerts = this.alerts.filter(
            (alert) => alert.text !== this.$t("app.alert.syncing")
          );

          if (!this.getAppLoader) {
            this.alerts.push({
              icon: true,
              text: this.$t("app.alert.synced"),
              class: "alert-message",
            });
          }

          setTimeout(() => {
            this.addChatUnreadMessagesRecievedWhileUpdating();
          }, 0);

          setTimeout(() => {
            this.checkOnboardFinished();
            this.alerts = [];
            this.alerts = this.alerts.filter(
              (alert) => alert.text !== this.$t("app.alert.synced")
            );
          }, 1000);
        })
        .catch((err) => {
          console.log("Get Data Error", err);
          this.$socket.disconnect();
        });
    },
    handleSocketDisconnected() {
      this.alerts = [];
      this.alerts.push({
        icon: true,
        text: this.$t("app.alert.connecting"),
        class: "alert-message",
      });
    },
    forceLogout() {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;
      clearInterval(this.interval);
      clearTimeout(this.reconnectTimeout);
      localStorage.clear();
      window.location.href = "/";
    },
    typeInInput(el, text, delay = 50) {
      return new Promise((resolve) => {
        let i = 0;

        // очищаем инпут перед началом
        el.value = "";
        const event = new Event("input", { bubbles: true });
        el.dispatchEvent(event);

        const type = () => {
          if (i < text.length) {
            const currentValue = el.value;
            const expectedChar = text.charAt(i);

            // проверяем, есть ли уже нужная буква в этой позиции
            if (currentValue.charAt(i) !== expectedChar) {
              el.value = currentValue + expectedChar;

              // обновляем Vue через событие
              const inputEvent = new Event("input", { bubbles: true });
              el.dispatchEvent(inputEvent);
            }

            i++;
            setTimeout(type, delay);
          } else {
            resolve(); // ✅ когда весь текст совпадает
          }
        };

        type();
      });
    },
    onboardShare(data) {
      return new Promise((resolve) => {
        this.moveToTarget(".project-settings__list:nth-child(2)").then(() => {
          this.$root.$emit("onboard:share");
          setTimeout(() => {
            this.moveToTarget(".el-autocomplete.autocomplete_users").then(
              () => {
                document
                  .querySelector(
                    ".project_drawer .el-form-item.with_png.active .el-autocomplete input"
                  )
                  .focus();
                document
                  .querySelector(
                    ".project_drawer .el-form-item.with_png.active .el-autocomplete input"
                  )
                  .focus();
                this.typeInInput(
                  document.querySelector(
                    ".el-autocomplete.autocomplete_users input"
                  ),
                  data.email
                ).then(() => {
                  document
                    .querySelector(
                      ".project_drawer .el-form-item.with_png.active .el-autocomplete input"
                    )
                    .focus();
                  setTimeout(() => {
                    this.moveToTarget(".drawer_users_in_project_item").then(
                      () => {
                        setTimeout(() => {
                          document
                            .querySelector(
                              ".el-scrollbar__view.el-autocomplete-suggestion__list li:first-child"
                            )
                            .click();
                          // this.$root.$emit('onboard:checkUsers', data.email)
                          setTimeout(() => {
                            this.moveToTarget(
                              ".form_header .el-button.el-button--primary"
                            ).then(() => {
                              this.$root.$emit("onboard:clickCreateList");
                              setTimeout(() => {
                                this.$socket.emit("IN_Onboard", {
                                  type: "finish",
                                });
                                this.$nextTick(() => {
                                  this.$refs.circle.style.display = "none";
                                  this.$refs.onboard_backgraund.style.display =
                                    "none";
                                });
                                this.$root.$emit("onboard:alert", false);
                                this.alerts = [];
                                resolve();
                              }, 1000);
                            });
                          }, 1000);
                        }, 3000);
                      }
                    );
                  }, 1000);
                });
              }
            );
          }, 1000);
        });
      });
    },
    onboardCreateTask(data) {
      return new Promise((resolve) => {
        this.moveToTarget(".add-task__input").then(() => {
          this.typeInInput(
            document.querySelector(".add-task__input input"),
            data.task_name
          ).then(() => {
            setTimeout(() => {
              this.$root.$emit("onboard:createTask");
              resolve();
            }, 1000);
          });
        });
      });
    },
    onboardCreateList(data) {
      return new Promise((resolve) => {
        this.moveToTarget(".sidebar_info_btn").then(() => {
          this.$root.$emit("onboard:openMenuCreateList");
          setTimeout(() => {
            this.moveToTarget(".sidebar__info .create_lists .list").then(() => {
              this.$root.$emit("onboard:openPopupCreateList");
              setTimeout(() => {
                this.moveToTarget(".project_name_input.el-input input").then(
                  () => {
                    this.typeInInput(
                      document.querySelector(
                        ".project_name_input.el-input input"
                      ),
                      data.list_name
                    ).then(() => {
                      setTimeout(() => {
                        this.moveToTarget(
                          ".form_header .el-button.el-button--primary"
                        ).then(() => {
                          this.$root.$emit("onboard:clickCreateList");
                          setTimeout(() => {
                            resolve();
                          }, 1000);
                        });
                      }, 1000);
                    });
                  }
                );
              }, 1000);
            });
          }, 1000);
        });
      });
    },
    onboardCircleClickEffect() {
      document.querySelector(".circle").classList.add("click");
      setTimeout(() => {
        document.querySelector(".circle").classList.remove("click");
      }, 300);
    },
    moveToTarget(el) {
      return new Promise(async (resolve) => {
        const target = document.querySelector(el).getBoundingClientRect();
        const circleSize = 10;

        // Центр элемента
        const targetX = target.left + target.width / 2 - circleSize / 2;
        const targetY = target.top + target.height / 2 - circleSize / 2;

        // Плавное движение
        await this.animateMove(targetX, targetY);
        setTimeout(() => {
          resolve(); // ✅ Promise выполнен
        }, 500);
      });
    },
    animateMove(targetX, targetY) {
      const speed = 5; // пикселей за кадр

      return new Promise((resolve) => {
        const step = () => {
          const dx = targetX - this.circleX;
          const dy = targetY - this.circleY;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < speed) {
            // дошли до цели
            this.circleX = targetX;
            this.circleY = targetY;
            resolve(); // ✅ Promise выполнен
            return;
          }

          // равномерное движение
          this.circleX += (dx / distance) * speed;
          this.circleY += (dy / distance) * speed;

          requestAnimationFrame(step);
        };
        step();
      });
    },
    checkOnboardFinished() {
      // if (this.getUserData.onboard_finished === undefined) return
      // console.log('Onboard Finished:', this.getUserData.onboard_finished)
      // if (!this.getUserData.onboard_finished) {
      //   this.$router.push({ name: 'Onboard' })
      // }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.reconnectTimeout);
  },
  created() {
    if (
      !localStorage.getItem("showSmallActivityLog") ||
      localStorage.getItem("showSmallActivityLog") == "true"
    )
      window.addEventListener("resize", this.watchWindowWidth);
  },
  computed: {
    ...mapGetters([
      "getAppLoader",
      "getUserData",
      "get_flag_for_send_firebase_token",
      "getProjects",
      "getTasks",
      "getChats",
      "getCompletedTasks",
      "get_reloadData",
    ]),
  },
  watch: {
    "$store.state.key.user": {
      handler(v) {
        if (this.getUserData.theme) {
          let theme = this.getUserData.theme.name;
          document.body.classList.forEach((cls) => {
            if (cls.startsWith("theme-")) {
              document.body.classList.remove(cls);
            }
          });
          document.body.classList.add("theme-" + theme);

          document.body.dataset.color = this.getUserData.theme.color;

          if (this.getUserData.theme.dark_mode) {
            document.body.classList.add("dark-mode");
          } else {
            document.body.classList.remove("dark-mode");
          }
        }

        this.onboard =
          v.onboard_finished != undefined ? v.onboard_finished : true;
      },
      deep: true,
    },
    get_reloadData() {
      setTimeout(() => {
        this.renderImageTeamsAndKnow();
      }, 500);
    },
    get_flag_for_send_firebase_token(e) {},
    $route(to) {
      this.checkOnboardFinished();
      this.changeTitle(to);
    },
  },
};
</script>
